import Form from "../../components/form/form";
import Joi from "joi-browser";
import React from "react";
import ServiceCenterService from "../../services/serviceCenterService";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import "./serviceCenter.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import ReCAPTCHA from "react-google-recaptcha";
import Auth from "../../services/authService";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { getServices } from "../../constants/ServiceCenter-constants";
import { getProvinces } from "../../constants/provinces-constant";

export default class serviceCenter extends Form {

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            isLoading: false,
            captchaRef: "",
            serviceCategories: [...getServices()],
            isServiceCategoriesSelected: false,
            selectedService: "null",
            proviences: [...getProvinces()],
            isProviencesSelected: false,
            selectedProvience: "null",
            hasHavayarProduction: [
                { key: "0720ecbc-8380-11ed-a1eb-0271ac18431", value: "1", label: "بلی" },
                { key: "0720ef8c-8380-11ed-a1eb-0271ac18432", value: "2", label: "خیر" }],
            ishasHavayarProductionSelected: false,
            selectedhasHavayarProduction: "null",
        };
    }

    state = {
        data: {
            CustomerTitle: "",
            CustomerPhone: "",
            RequestText: "",
            RequestType: "",
            RequestTypeId: "",
            Province: "",
            ProvinceId: "",
            havayarProduction: "",
            havayarProductionId: "",
        },
        errors: {},
    };

    schema = {
        CustomerTitle: Joi.string().required().error(new Error("نام درخواست دهنده")),
        CustomerPhone: Joi.string().required().error(new Error("شماره همراه")),
        RequestText: Joi.string().required().error(new Error("شرح درخواست")),
        RequestType: Joi.string().required().error(new Error("نوع درخواست")),
        RequestTypeId: Joi.string().required().error(new Error("نوع درخواست")),
        province: Joi.string().required().error(new Error("استان")),
        provinceId: Joi.string().required().error(new Error("استان")),
        havayarProduction: Joi.string().required().error(new Error("آیا محصول هوایاری دارید")),
        havayarProductionId: Joi.string().required().error(new Error("آیا محصول هوایاری دارید"))
    };

    onChange = async (value) => {
        this.setState({ captchaRef: value });
    }

    doSubmit = async () => {
        const { data } = this.state;
        try {
            if (!this.state.captchaRef) {
                toast.error("کپچا الزامی است");
                const isLoading = false;
                this.setState({ isLoading: isLoading });
                return;
            }
            var result = await ServiceCenterService.RegisterServiceCenterRequest(
                data.CustomerTitle,
                data.CustomerPhone,
                data.RequestText,
                data.RequestType,
                data.RequestTypeId,
                data.provinceId,
                data.province,
                data.havayarProduction,
                this.state.captchaRef
            );
            console.log("result : ", result);
            const isLoading = false;
            const showSuccessMessage = true;
            this.setState({ isLoading: isLoading });
            this.setState({ showSuccessMessage: showSuccessMessage });

        } catch (ex) {
            //if (ex.code !== "ERR_NETWORK") {
            //    toast.error(ex.response.data.Message);
            //}
            //const isLoading = false;
            //this.setState({ isLoading: isLoading });
            const isLoading = false;
            const showSuccessMessage = true;
            this.setState({ isLoading: isLoading });
            this.setState({ showSuccessMessage: showSuccessMessage });
        }
    };


    handleServiceCategoriesSelect = service => {
        this.setState({ selectedService: service.value }, () => {
            this.state.data.RequestType = service.label;
            this.state.data.RequestTypeId = service.id;
        });
    };

    handleProviencesSelect = province => {
        this.setState({ selectedProvience: province.value }, () => {
            this.state.data.province = province.label;
            this.state.data.provinceId = province.value;
        });
    };

    handleHavayarProductionSelect = havayarProduction => {
        this.setState({ selectedhasHavayarProduction: havayarProduction.value }, () => {
            this.state.data.havayarProduction = havayarProduction.label;
            this.state.data.havayarProductionId = havayarProduction.value;
        });
    };

    render() {
        // if (!Auth.getCurrentUser()) return (window.location = "/login");

        return (
            <Page>
                <Header />
                <section className="container">
                    <div className="row hrow itemsrow" >
                            <div className="col-12 product_present">
                                <h3 className="subject m-5">معرفی مرکز خدمات پس از فروش هوایار</h3>
                                <p style={{ textAlign: "justify" }}>
                                    واحــد خدمــات پــس از فــروش هوایــار بــا پشــتوانه ربــع قــرن تجربــه در زمینــه ارائــه خدمــات انــواع تجهیــزات هــوای فشــرده، بــا اتــکاء بــر دانــش و تخصــص پرســنل توانمنــد خــود، اقــدام بــه تاســیس مرکــز تخصصــی تعمیــرات، نگهــداری و بهــره بــرداری صنایــع مهــم و اســتراتژیک کشــور نمــوده اســت. ایـن مرکـز، خدمـات تخصصـی خـود را عـلاوه بـر محصـولات هوایـار، بـر دیگـر برندهـای مطـرح دنیـا نیـز بـه صـورت کارآمـد و مطمئـن متمرکـز کـرده اسـت.
                                </p>
                            <img className="img-fluid centerimg" src={`../assets/images/sample/ServiveCenter.png`} alt="" />
                            </div>
                    </div>
                </section>
                <section className="container consuling">
                    <div className="row hrow headbox-dark">
                        <h3 className="title">ثبت درخواست خدمات پشتیبانی</h3>
                    </div>
                    <div className="row">
                        <form onSubmit={this.handleSubmit} action="/">
                            <div className="mb-4 mt-3">
                                <small style={{ color: "red" }}>اجباری</small>
                                <DropDownWhiteStyle
                                    items={this.state.serviceCategories}
                                    placeholder="خدمت درخواستی"
                                    onItemSelect={this.handleServiceCategoriesSelect}
                                />
                            </div>
                            <div className="mb-4 mt-3">
                                <small style={{ color: "red" }}>اجباری</small>
                                <DropDownWhiteStyle
                                    items={this.state.proviences}
                                    placeholder="استان"
                                    onItemSelect={this.handleProviencesSelect}
                                />
                            </div>
                            <div className="mb-4 mt-3">
                                <small style={{ color: "red" }}>اجباری</small>
                                <DropDownWhiteStyle
                                    items={this.state.hasHavayarProduction}
                                    placeholder="آیا از محصولات هوایار دارید؟"
                                    onItemSelect={this.handleHavayarProductionSelect}
                                />
                            </div>
                            <div className="mb-4 mt-3">
                                {this.renderInput(
                                    "CustomerTitle",
                                    "",
                                    "نام درخواست دهنده",
                                    "text",
                                    "form-control form-control-lg",
                                    "true"
                                )}
                            </div>
                            <div className="mb-4">
                                {this.renderInput(
                                    "CustomerPhone",
                                    "",
                                    "شماره همراه",
                                    "text",
                                    "form-control form-control-lg",
                                    "true"
                                )}
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="visually-hidden form-label"
                                >
                                    شرح موضوع
                                </label>
                                {this.renderTextArea(
                                    "RequestText",
                                    "شرح درخواست",
                                    "form-control form-control-lg",
                                    3,
                                    "true"
                                )}
                            </div>
                            <div className="d-flex justify-content-center m-4" >
                                <ReCAPTCHA
                                    sitekey={process.env.REACT_APP_SITE_KEY}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="d-grid mb-4">
                                {this.renderButtonWithSpinner("ثبت درخواست پشتیبانی", "btn btn-primary")}
                            </div>
                        </form>
                    </div>
                </section>
                <section className="container">
                    <div className="row hrow mt-4">
                        <Link className="btn btn-dark" to="/profile">پروفایل من</Link>
                    </div>
                </section>
                <Footer />
            </Page>
        );
    }
}
